/* eslint-disable import/no-named-as-default-member */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable max-len */
/* eslint-disable react/style-prop-object */
/* eslint-disable jsx-a11y/control-has-associated-label */

import React, {
    useEffect, useState, useCallback, useContext,
} from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import HeaderContext from '../../../Components/Context/HeaderContext';
import { distributorService } from '../../../service/distributor.service';
import Pagination from '../../../Components/Pagination';
import EmptyScreen from '../../../Components/GlobalEmplyPage';
import CustomerListSkeleton from './customerListSkeleton';
import CustomerWiseFilterModal from './FilterModal';
import { CamelCase, PriceHandler } from '../../../redux/helper/CamelCase';

function CustomerWiseOutstandingReport() {
    const {
        isPopup,
        setisPopup,
        ErrorMessage,
        SetErrorMessage,
        SuccessMessage,
        SetSuccessMessage,
        colorValue,
        setcolorValue,
    } = useContext(HeaderContext);
    const location = useNavigate();
    const [customerWiseOutstandingList, setCustomerWiseOutstandingtList] = useState([]);
    const [summary, setSummary] = useState([]);
    const [sortType, setsortType] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [searchValue, setsearchValue] = useState('');
    const [totalPage, setTotalPage] = useState('');
    const [loading, setLoading] = useState(true);
    const [filterModal, setFilterModal] = useState(false);
    const [filterValue, setfilterValue] = useState('');
    const [emptyData, setEmptyData] = useState(false);
    const [selected, setselected] = useState({
        start_date: '',
        end_date: '',
    });
    const [Filter, setFilter] = useState({
        customer_code: [],
    });
    const [exportClick, setexportClick] = useState(false);
    const [exportSelected, setexportSelected] = useState('');

    const handleFetchCustomerWiseOutstandingReport = useCallback((() => {
        distributorService.MISCustomerWiseOutstandingReportList(currentPage, '', searchValue, filterValue).then((response) => {
            if (response.error === false && response.data.success_status === true) {
                if (response.data.data.length === 0) {
                    setLoading(false);
                    setEmptyData(true);
                } else {
                    setEmptyData(false);
                    setLoading(false);
                }
                setLoading(false);
                setCustomerWiseOutstandingtList(response.data.data);
                setSummary(response.data.summary);
                setCurrentPage(response.data.current_page);
                setTotalPage(response.data.number_of_pages);
            } else {
                setLoading(false);
            }
        });
    }), [currentPage, searchValue, sortType, filterValue]);

    const handleViewCustomer = async (id) => {
        location(`/mis-reports/customer-wise-outstanding-report/${id.CUSTOMER_NO}`);
    };

    const handlePageClick = async (data) => {
        setLoading(false);
        const page = data.selected + 1;
        setCurrentPage(page);
    };

    const handleClear = () => {
        setFilter({
            customer_code: [],
        });
        setselected({ start_date: '', end_date: '' });
        setfilterValue('');
        handleFetchCustomerWiseOutstandingReport();
        setFilterModal(false);
        SetSuccessMessage('Filters cleared Successfully!');
        setTimeout(() => {
            SetSuccessMessage('');
        }, 2000);
    };

    const handleFilter = (filterUrl) => {
        if (filterUrl.length > 0 && filterValue !== filterUrl) {
            setLoading(true);
            setCurrentPage(1);
            setfilterValue(filterUrl);
        } else {
            setLoading(false);
            setfilterValue(filterUrl);
        }
    };

    const handleExport = useCallback((() => {
        distributorService.MISCustomerWiseOutstandingReportList(currentPage, sortType, searchValue, filterValue, exportSelected).then((val) => {
            if (val.data.success_status) {
                // setshowPopup(true);
                SetSuccessMessage(val.data.message);
                setexportClick(false);
                setexportSelected('');
                window.open(val.data.url, '_blank');
                setTimeout(() => {
                    // settitle('');
                    SetSuccessMessage('');
                }, 2000);
            }
        });
    }), [exportSelected]);

    useEffect(() => {
        if (exportSelected !== '') {
            handleExport();
        }
    }, [handleExport]);

    useEffect(() => {
        handleFetchCustomerWiseOutstandingReport();
    }, [handleFetchCustomerWiseOutstandingReport]);

    return (
        <div className="py-6 pr-[18px] main-screen">
            <div className="flex justify-between pb-[18px]">
                <h5 className="text-xs4 font-normal text-[#555259]">Customer Wise Outstanding Report</h5>
                <div className="flex">
                    <button
                        type="button"
                        className="bg-[#F5F5FA] font-bold text-xs h-9 text-[#555259] border-2 border-[#E9EDF4] py-1 px-4 rounded-[9px] mr-2.5"
                        style={{
                            border: '2px solid #E9EDF4',
                        }}
                        data-bs-toggle="modal"
                        data-bs-target="#filtermodal"
                        onClick={() => setFilterModal(true)}
                    >
                        Filter
                    </button>
                    <div className="relative mr-2">
                        <label htmlFor="search" />
                        <input
                            type="text"
                            name="search"
                            id="search"
                            className="w-[230px] h-[35px] bg-[#FFFFFF] rounded-lg outline-0 shadow-s3 text-xs2 font-semibold text-[#808285] placeholder:font-semibold placeholder:text-xs2 placeholder:text-[#808285] pl-[35px] pr-[15px]"
                            placeholder="Search"
                            value={searchValue}
                            onChange={(e) => {
                                setsearchValue(e.target.value);
                                setCurrentPage(1);
                            }}
                            autoComplete="off"
                        />
                        <img src="/images/Group-279.svg" alt="icon" className="absolute top-3 left-[15px] cursor-pointer" />
                    </div>
                    <div className="mr-2 dropdown relative">
                        <button
                            type="button"
                            id="exportDropdown"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            className="dropdown-toggle h-[35px] text-xs2 font-semibold text-[#555259] w-[79px] border border-[#555259] rounded-lg"
                            onClick={() => setexportClick(!exportClick)}
                        >
                            Export
                        </button>
                        <ul className={`dropdown-menu min-w-[100px] absolute ${exportClick === true ? 'show' : 'hidden'} bg-[#FFFFFF] rounded-lg shadow-s2 z-[3]`} aria-labelledby="exportDropdown">
                            <li className="mx-[18px] pb-1.5 mt-5 hover:bg-[#F2F2F3] hover:rounded export">
                                <a
                                    className="dropdown-item text-xs5 font-normal text-[#555259] w-full inline-block px-1.5 py-0.5"
                                    href="#"
                                    onClick={() => {
                                        setexportSelected('csv');
                                    }}
                                >
                                    CSV
                                </a>
                            </li>
                            <li className="mx-[18px] pb-1.5 hover:bg-[#F2F2F3] hover:rounded">
                                <a
                                    className="dropdown-item text-xs5 font-normal text-[#555259] w-full inline-block px-1.5 py-0.5"
                                    href="#"
                                    onClick={() => setexportSelected('pdf-converter')}
                                >
                                    PDF
                                </a>
                            </li>
                            <li className="mx-[18px] pb-1.5 mb-3 hover:bg-[#F2F2F3] hover:rounded">
                                <a
                                    className="dropdown-item text-xs5 font-normal text-[#555259] w-full inline-block px-1.5 py-0.5"
                                    href="#"
                                    onClick={() => setexportSelected('excel')}
                                >
                                    Excel
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            {loading ? <CustomerListSkeleton /> : (
                <div>
                    {customerWiseOutstandingList.length > 0 && (
                        <div
                            className="overflow-auto dropdown-menu pb-7 relative z-10"
                            style={{ height: 'calc(100vh - 325px)' }}
                        >
                            <table className="w-full table-auto relative">
                                <thead className="top-0 left-0 sticky z-[2]">
                                    <tr className="bg-[#555259] h-10">
                                        <th className="py-2.5 px-6 rounded-bl-lg rounded-tl-lg min-w-[300px] sticky top-0 left-0 bg-[#555259]" scope="col">
                                            <span className="text-xs5 font-bold text-[#FFFFFF]">
                                                Customer Name
                                            </span>
                                        </th>
                                        <th scope="col" className="py-2.5 px-7 min-w-[168px]">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center">
                                                Customer Code
                                            </span>
                                        </th>
                                        <th scope="col" className="py-2.5 px-7 min-w-[250px]">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center">
                                                Total Outstanding
                                            </span>
                                        </th>
                                        <th scope="col" className="py-2.5 px-7 min-w-[150px] text-center flex justify-center items-center pt-4">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center">
                                                Current Total
                                            </span>
                                        </th>
                                        <th scope="col" className="py-2.5 px-7 min-w-[230px]">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-end">
                                                Total Due
                                            </span>
                                        </th>
                                        <th scope="col" className="py-2.5 px-7 min-w-[188px]">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-end">
                                                30 Days Total
                                            </span>
                                        </th>
                                        <th scope="col" className="py-2.5 px-7 min-w-[188px]">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-end">
                                                60 Days Total
                                            </span>
                                        </th>
                                        <th scope="col" className="py-2.5 px-7 min-w-[188px]">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-end">
                                                90 Days Total
                                            </span>
                                        </th>
                                        <th scope="col" className="py-2.5 px-7 min-w-[188px]">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-end">
                                                180 Days Total
                                            </span>
                                        </th>
                                        <th scope="col" className="py-2.5 px-7 min-w-[188px]">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-end">
                                                360 Days Total
                                            </span>
                                        </th>
                                        <th scope="col" className="py-2.5 px-7 min-w-[152px] rounded-tr-lg rounded-br-lg sm:sticky top-0 right-0 bg-[#555259]">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center">
                                                Actions
                                            </span>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr className="bg-[#FFFFFF] border-b border-[#DFEAF7] ">
                                        <td
                                            className="text-sm font-normal text-[#090406] py-2.5 px-7 sticky left-0 flex justify-center items-center pt-4 z-[1]"
                                            style={{
                                                background: 'rgba(255, 255, 255, 0.45)',
                                                backdropFilter: 'blur(5.5px)',
                                            }}
                                        />
                                        <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-center" />
                                        <td className="text-sm font-normal text-[#090406] text-center py-2.5 px-7">
                                            {PriceHandler(summary.TOTAL_OUTSTANDING)}
                                        </td>
                                        <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-end">
                                            {PriceHandler(summary.CURRENT_TOTAL)}
                                        </td>
                                        <td className="text-sm font-normal py-2.5 px-7 text-end">
                                            {PriceHandler(summary.AMOUNT_DUE_REMAIN)}
                                        </td>
                                        <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-end">
                                            {PriceHandler(summary['30_DAYS'])}
                                        </td>
                                        <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-end">
                                            {PriceHandler(summary['60_DAYS'])}
                                        </td>
                                        <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-end">
                                            {PriceHandler(summary['90_DAYS'])}
                                        </td>
                                        <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-end">
                                            {PriceHandler(summary['180_DAYS'])}
                                        </td>
                                        <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-end">
                                            {PriceHandler(summary['360_DAYS'])}
                                        </td>
                                        <td
                                            className="py-2.5 px-7 sm:sticky right-0 z-[1]"
                                            style={{
                                                background: 'rgba(255, 255, 255, 0.45)',
                                                backdropFilter: 'blur(5.5px)',
                                            }}
                                        />
                                    </tr>
                                    {customerWiseOutstandingList.length > 0 && customerWiseOutstandingList.map((item) => (

                                        <tr className="bg-[#FFFFFF] border-b border-[#DFEAF7]">
                                            <td
                                                className="text-sm font-normal text-[#090406] py-2.5 px-7 sticky left-0 flex justify-center items-center pt-4 z-[1]"
                                                style={{
                                                    background: 'rgba(255, 255, 255, 0.45)',
                                                    backdropFilter: 'blur(5.5px)',
                                                }}
                                            >
                                                {item?.PARTY_NAME}
                                            </td>
                                            <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-center">
                                                {item?.CUSTOMER_NO}
                                            </td>
                                            <td className="text-sm font-normal text-[#090406] text-center py-2.5 px-7">
                                                {PriceHandler(item?.TOTAL_OUTSTANDING)}
                                            </td>
                                            <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-end">
                                                {PriceHandler(item?.CURRENT_TOTAL)}
                                            </td>
                                            <td className="text-sm font-normal py-2.5 px-7 text-end">
                                                {PriceHandler(item?.AMOUNT_DUE_REMAIN)}
                                            </td>
                                            <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-end">
                                                {PriceHandler(item['30_DAYS'])}
                                            </td>
                                            <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-end">
                                                {PriceHandler(item['60_DAYS'])}

                                            </td>
                                            <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-end">
                                                {PriceHandler(item['90_DAYS'])}
                                            </td>
                                            <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-end">
                                                {PriceHandler(item['180_DAYS'])}
                                            </td>
                                            <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-end">
                                                {PriceHandler(item['360_DAYS'])}
                                            </td>
                                            <td
                                                className="py-2.5 px-7 sm:sticky right-0 z-[1]"
                                                style={{
                                                    background: 'rgba(255, 255, 255, 0.45)',
                                                    backdropFilter: 'blur(5.5px)',
                                                }}
                                            >
                                                <div className="flex items-center justify-center">
                                                    <button
                                                        type="button"
                                                        className="font-semibold text-sm text-white bg-[#44445E] rounded-lg w-[72px] h-[34px]"
                                                        style={{
                                                            background: '#44445E',
                                                            padding: '5px 10px',
                                                            borderRadius: '4px',
                                                        }}
                                                        onClick={(e) => handleViewCustomer(item)}
                                                    >
                                                        View
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                    {customerWiseOutstandingList.length > 0 && customerWiseOutstandingList && (
                        <Pagination
                            handlePageClick={handlePageClick}
                            List={customerWiseOutstandingList}
                            currentPage={currentPage}
                            totalPage={totalPage}
                        />
                    )}
                    {filterModal && (
                        <CustomerWiseFilterModal
                            filterModal={filterModal}
                            setFilterModal={setFilterModal}
                            selected={selected}
                            setselected={setselected}
                            Filter={Filter}
                            setFilter={setFilter}
                            handleClear={handleClear}
                            setCustomerWiseOutstandingtList={setCustomerWiseOutstandingtList}
                            customerWiseOutstandingList={customerWiseOutstandingList}
                            handleFilter={handleFilter}
                            SetSuccessMessage={SetSuccessMessage}
                        />
                    )}
                </div>
            )}
            {emptyData && (
                <EmptyScreen
                    search="yes"
                    text="no Customer Wise Outstanding Report"
                    buttonRequired={false}
                    all={searchValue.length > 0 ? 'under searched term' : 'found'}
                />
            )}
        </div>
    );
}

export default CustomerWiseOutstandingReport;
